import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { TableData } from '@/utils/salt-item';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  data: TableData[];
  style?: StyleProp<ViewStyle>;
}

export const RichInfoTable: React.FC<Props> = ({ data, style }) => {
  const [styles] = useStyles();
  return (
    <View style={[styles.table, style]}>
      {data.map(({ key, value }, idx) => (
        <View
          key={key}
          style={[
            styles.tableRow,
            idx === data.length - 1 ? null : styles.borderBottom,
          ]}
        >
          <View
            style={[
              styles.tableData,
              styles.key,
              idx === 0
                ? styles.firstKey
                : idx === data.length - 1
                  ? styles.lastKey
                  : null,
            ]}
          >
            <Text style={[TYPOGRAPHY.xsmall, styles.text]}>{key}</Text>
          </View>
          <View style={[styles.tableData, styles.value]}>
            <Text style={[TYPOGRAPHY.xsmall, styles.text]}>{value}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  borderBottom: {
    borderBottomColor: theme.colors.inactiveText,
    borderBottomWidth: 1,
  },
  firstKey: {
    borderTopLeftRadius: 4,
  },
  key: {
    backgroundColor: theme.colors.offWhite,
    flex: 1,
  },
  lastKey: {
    borderBottomLeftRadius: 4,
  },
  table: {
    borderColor: theme.colors.inactiveText,
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 1,
  },
  tableData: {
    paddingHorizontal: 12,
    paddingVertical: 4,
  },
  tableRow: {
    flexDirection: 'row',
  },
  text: {
    color: theme.colors.black,
  },
  value: {
    borderLeftColor: theme.colors.inactiveText,
    borderLeftWidth: 1,
    flex: 2,
  },
}));
